<template>
  <section v-if="activePage!=='home'" id="briciole" class="container px-4 my-4">
    <div class="row">
      <div class="col px-lg-4">
        <nav class="breadcrumb-container" aria-label="breadcrumb">
          <app-breadcrumbs container="ol" aria-label="breadcrumb" class="breadcrumb">
            <li slot-scope="{to, label, utils}" class="breadcrumb-item">
              <router-link
                :to="to"
                class="your-custom-class"
                exact
                :itemprop="utils && utils.itemprop"
              >{{label}}</router-link>
              <span class="separator">/</span>
            </li>

            <span
              slot="current"
              slot-scope="{label}"
              class="custom-current-class"
            >{{label}}</span>
          </app-breadcrumbs>
        </nav>
      </div>
    </div>
  </section>
</template>

<script>
import sprites from 'bootstrap-italia/dist/svg/sprite.svg';

export default {
  name: 'bread-crumbs',
  components: {
  },
  mounted() {
    const currentRouteName = this.$router.currentRoute.name;
    this.activePage = currentRouteName;
  },
  watch: {
    // eslint-disable-next-line object-shorthand
    '$route'(to) {
      this.activePage = to.name;
    },
  },

  data() {
    return {
      icons: {
        itArrowUp: `${sprites}#it-arrow-up`,
      },
      activePage: 'home',
    };
  },

};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/layout/accessory/BreadCrumbs.vue